var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "my-3" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "リアルタイムプレビュー",
          },
          on: {
            click: function ($event) {
              _vm.previewMode = "realtime-view"
            },
          },
        },
        [_c("i", { staticClass: "fas fa-eye" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "PCプレビュー",
          },
          on: {
            click: function ($event) {
              _vm.previewMode = "pc-view"
            },
          },
        },
        [_c("i", { staticClass: "fas fa-desktop" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "モバイルプレビュー",
          },
          on: {
            click: function ($event) {
              _vm.previewMode = "sp-view"
            },
          },
        },
        [_c("i", { staticClass: "fas fa-mobile-alt" })]
      ),
      _vm._v(" "),
      _vm._m(0),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "overflow-auto", attrs: { id: "preview-elements-block" } },
      [
        _vm.previewMode === "realtime-view"
          ? _c("div", { staticClass: "pc-view" }, [
              _c(
                "nav",
                {
                  staticClass:
                    "navbar navbar-expand-lg navbar-dark bgr-nav scrolled",
                  style: "background-color: " + _vm.navbarBgColor,
                },
                [
                  _c("div", { staticClass: "container" }, [
                    _c("a", { staticClass: "navbar-brand" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: { src: _vm.logo },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("button", {
                      staticClass: "navbar-toggler",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": ".navbar-collapse",
                        "aria-expanded": "false",
                        "aria-label": "Toggle navigation",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "collapse navbar-collapse justify-content-end",
                      },
                      [
                        _c("div", { staticClass: "py-2 py-lg-0" }, [
                          _c(
                            "ul",
                            { staticClass: "navbar-nav" },
                            _vm._l(_vm.visibilitymMenuData, function (item) {
                              return _c(
                                "li",
                                {
                                  key: item.name,
                                  staticClass: "nav-item dropdown",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link",
                                      style: "color: " + _vm.navTextColor,
                                    },
                                    [_vm._v(_vm._s(item.view_name))]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "container-fruid content mt-0" }, [
                _c("div", { staticClass: "shool-top bg-white" }, [
                  _c("div", { attrs: { id: "page_body_preview" } }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.pageBodyPreview) },
                    }),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.previewMode === "pc-view"
          ? _c("div", { staticClass: "pc-view" }, [
              _c("iframe", { attrs: { src: "/" } }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.previewMode === "sp-view"
          ? _c("div", { staticClass: "sp-view" }, [
              _c("iframe", { attrs: { src: "/" } }),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn",
        attrs: {
          "data-toggle": "tooltip",
          "data-placement": "top",
          title: "ブラウザで開く",
          href: "/",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fas fa-external-link-alt" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }